var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUkraineFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2230_42450)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2230_42450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.64674 0H28.3478C29.2554 0 29.9946 0.708333 29.9946 1.57812V18.4167C29.9946 19.2865 29.25 19.9948 28.3478 19.9948H1.64674C0.744565 20 0 19.2917 0 18.4219V1.57812C0 0.708333 0.744565 0 1.64674 0Z",
    fill: "#005BBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10H30V18.4219C30 19.2917 29.2554 20 28.3533 20H1.64674C0.744565 20 0 19.2917 0 18.4219V10Z",
    fill: "#FFD500"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2230_42450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2230_42450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkraineFlag);
export default __webpack_public_path__ + "static/media/ukraine_flag.b150c8a0cb33176a06a2fec26917a7ba.svg";
export { ForwardRef as ReactComponent };